
import PrivacyPolicy from './PrivacyPolicy';
import TermsConditions from './TermsConditions';
import { useState } from "react";

const App = () => {
  function switchLanguage(lang) {
    document.querySelectorAll("[data-lang-en]").forEach((el) => {
      el.textContent = el.getAttribute("data-lang-" + lang);
    });
  }

  const [visibleSection, setVisibleSection] = useState(null);

  const toggleSection = (section) => {
    setVisibleSection((prev) => (prev === section ? null : section));
    setTimeout(() => {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };




  return (
    <>
      <nav className="sticky-nav shadow-md">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex space-x-6 text-sm sm:text-base">
            <a className="hover:text-blue-400" href="#about">
              About
            </a>
            <a className="hover:text-blue-400" href="#services">
              Services
            </a>
            <a className="hover:text-blue-400" href="#plans">
              Plans
            </a>
            <a
              className="hover:text-blue-400"
              href="#faq"
              onClick={() => {
                const f = document.getElementById("faq-section");
                f.classList.toggle("hidden");
                f.scrollIntoView({ behavior: "smooth" });
              }}
            >
              FAQ
            </a>
            <a
              className="hover:text-blue-400"
              href="#contact"
              onClick={() => {
                const c = document.getElementById("contact-form");
                c.classList.toggle("hidden");
                c.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Contact
            </a>
          </div>
          <div className="text-sm">
            <div className="flex items-center space-x-2 text-sm">
              <div className="flex items-center space-x-3 text-xl">
                <span
                  className="cursor-pointer hover:scale-110 transition"
                  onClick={() => switchLanguage("en")}
                >
                  🇺🇸
                </span>
                <span
                  className="cursor-pointer hover:scale-110 transition"
                  onClick={() => switchLanguage("ar")}
                >
                  🇪🇬
                </span>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <header
        className="bg-cover bg-center h-64 flex items-center justify-center animated-bg"
        style={{
          backgroundColor: "#000000",
          backgroundImage:
            "radial-gradient(circle at center, rgba(255,255,255,0.05) 0%, transparent 70%)",
          height: "16rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <h1 className="text-5xl font-bold text-white bg-black bg-opacity-50 px-4 py-2 rounded">
          Welcome to My Portfolio
        </h1>
      </header>
      <section
        className="text-center py-16 px-4"
        data-aos="fade-up"
        id="about"
        style={{
          backgroundColor: "#000000",
          backgroundImage:
            "radial-gradient(circle at center, rgba(255,255,255,0.04) 0%, transparent 70%)",
        }}
      >
        <h2
          className="text-4xl font-bold mb-6"
          data-lang-ar="معلومات عني"
          data-lang-en="About Me"
        >
          About Me
        </h2>
        <div className="max-w-2xl mx-auto text-gray-300 text-lg leading-relaxed space-y-3">
          <p className="text-3xl font-bold">
            I am Jalal Ali, a professional app developer
          </p>
          <p className="text-xl">
            with over 5 years of experience. I use Laravel, Node.js,
          </p>
          <p className="text-lg">
            {" "}
            Tailwind CSS, and develop TV apps and smart{" "}
          </p>
          <p className="text-lg">interfaces.</p>
        </div>
      </section>
      <section
        className="text-center py-12"
        data-aos="fade-right"
        id="services"
      >
        <h2
          className="text-4xl font-bold mb-8"
          data-lang-ar="الخدمات"
          data-lang-en="Services"
        >
          Services
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-4xl mx-auto text-lg font-medium">
          <div className="bg-gray-800 p-4 rounded">Web Development</div>
          <div className="bg-gray-800 p-4 rounded">UI/UX Design</div>
          <div className="bg-gray-800 p-4 rounded">Payment Gateways</div>
          <div className="bg-gray-800 p-4 rounded">Hosting &amp; Domains</div>
          <div className="bg-gray-800 p-4 rounded">SSL Certificate</div>
          <div className="bg-gray-800 p-4 rounded">Ad Training & Campaign Optimization</div>

        </div>
      </section>
    <section className="text-center py-12 px-4" data-aos="zoom-in" id="plans">
  <h2 className="text-4xl font-bold mb-8" data-lang-ar="الخطط والأسعار" data-lang-en="Plans & Pricing">
    الخطط والأسعار
  </h2>

  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto text-sm font-medium">
    {/* ✅ Basic Plan */}
    <div className="bg-gray-800 p-4 rounded text-center space-y-2">
      <h3 className="text-lg font-medium mb-2">Basic Plan</h3>
      <p className="text-sm text-gray-400 mb-2" data-lang-ar="موقع صفحة واحدة ثابت" data-lang-en="Single-page static website">
        موقع صفحة واحدة ثابت
      </p>
      <p className="text-xl font-semibold mb-4" data-lang-ar="٤٬٥٠٠ جنيه" data-lang-en="EGP 4,500">٤٬٥٠٠ جنيه</p>
      <button
        className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded"
        data-lang-ar="احجز الآن"
        data-lang-en="Book Now"
        onClick={() => document.getElementById("shared-payment-form").classList.toggle("hidden")}
      >
        احجز الآن
      </button>
    </div>

    {/* ✅ Advanced Plan */}
    <div className="bg-gray-800 p-4 rounded text-center space-y-2">
      <h3 className="text-lg font-medium mb-2">Advanced Plan</h3>
      <p className="text-sm text-gray-400 mb-2" data-lang-ar="موقع ديناميكي + لوحة تحكم" data-lang-en="Dynamic website + dashboard">
        موقع ديناميكي + لوحة تحكم
      </p>
      <p className="text-xl font-semibold mb-4" data-lang-ar="١٠٬٥٠٠ جنيه" data-lang-en="EGP 10,500">١٠٬٥٠٠ جنيه</p>
      <button
        className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded"
        data-lang-ar="احجز الآن"
        data-lang-en="Book Now"
        onClick={() => document.getElementById("shared-payment-form").classList.toggle("hidden")}
      >
        احجز الآن
      </button>
    </div>

    {/* ✅ Full Business */}
    <div className="bg-gray-800 p-4 rounded text-center space-y-2">
      <h3 className="text-lg font-medium mb-2">Full Business</h3>
      <p className="text-sm text-gray-400 mb-2" data-lang-ar="دومين + استضافة + شهادة SSL" data-lang-en="Domain + hosting + SSL">
        دومين + استضافة + شهادة SSL
      </p>
      <p className="text-xl font-semibold mb-4" data-lang-ar="٣٦٬٠٠٠ جنيه" data-lang-en="EGP 36,000">٣٦٬٠٠٠ جنيه</p>
      <button
        className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded"
        data-lang-ar="احجز الآن"
        data-lang-en="Book Now"
        onClick={() => document.getElementById("shared-payment-form").classList.toggle("hidden")}
      >
        احجز الآن
      </button>
    </div>

    {/* ✅ E-Commerce */}
    <div className="bg-gray-800 p-4 rounded text-center space-y-2">
      <h3 className="text-lg font-medium mb-2">E-Commerce</h3>
      <p className="text-sm text-gray-400 mb-2" data-lang-ar="بوابات دفع وشحن" data-lang-en="Payment + shipping gateways">
        بوابات دفع وشحن
      </p>
      <p className="text-xl font-semibold mb-4" data-lang-ar="٢٥٬٥٠٠ جنيه" data-lang-en="EGP 25,500">٢٥٬٥٠٠ جنيه</p>
      <button
        className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded"
        data-lang-ar="احجز الآن"
        data-lang-en="Book Now"
        onClick={() => document.getElementById("shared-payment-form").classList.toggle("hidden")}
      >
        احجز الآن
      </button>
    </div>

    {/* ✅ Mobile App */}
    <div className="bg-gray-800 p-4 rounded text-center space-y-2">
      <h3 className="text-lg font-medium mb-2">Mobile App</h3>
      <p className="text-sm text-gray-400 mb-2" data-lang-ar="تطبيقات أندرويد و iOS" data-lang-en="Android and iOS">
        تطبيقات أندرويد و iOS
      </p>
      <p className="text-xl font-semibold mb-4" data-lang-ar="٣٦٬٠٠٠ جنيه" data-lang-en="EGP 36,000">٣٦٬٠٠٠ جنيه</p>
      <button
        className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded"
        data-lang-ar="احجز الآن"
        data-lang-en="Book Now"
        onClick={() => document.getElementById("shared-payment-form").classList.toggle("hidden")}
      >
        احجز الآن
      </button>
    </div>
    {/* ✅ Ad Training Service */}
<div className="bg-gray-800 p-4 rounded text-center space-y-2">
  <h3 className="text-lg font-medium mb-2" data-lang-ar="كورس إعلانات وتسويق" data-lang-en="Ad Training & Marketing Course">
    Ad Training & Marketing Course
  </h3>
  <p className="text-sm text-gray-400 mb-2" data-lang-ar="تعلم إعداد الحملات الإعلانية بميزانية منخفضة وتحقيق أعلى النتائج" data-lang-en="Learn to run ad campaigns with low budget and high ROI">
    Learn to run ad campaigns with low budget and high ROI
  </p>
  <p className="text-xl font-semibold mb-4" data-lang-ar="٥٬٥٠٠ جنيه" data-lang-en="EGP 5,500">
    EGP 5,500
  </p>
  <button
    className="bg-blue-600 hover:bg-blue-700 transition text-white px-4 py-2 rounded"
    data-lang-ar="احجز الآن"
    data-lang-en="Book Now"
    onClick={() => {
      document.getElementById("shared-payment-form").classList.toggle("hidden");
    }}
  >
    احجز الآن
  </button>
</div>

  </div>


  

  {/* ✅ طرق الدفع داخل نفس القسم */}
  <div
    className="hidden mt-10 bg-gray-800 p-6 rounded shadow max-w-xl mx-auto"
    id="shared-payment-form"
  >
    <h3 className="text-xl font-bold mb-4 text-center text-white" data-lang-ar="أكمل الحجز" data-lang-en="Complete Your Booking">
      أكمل الحجز
    </h3>
    <p className="font-semibold text-white" data-lang-ar="طرق الدفع" data-lang-en="Payment Methods">
      طرق الدفع
    </p>
    <div className="flex justify-center space-x-3 mb-4">
      <span className="bg-gray-700 px-3 py-1 rounded text-sm">💳 Visa</span>
      <span className="bg-gray-700 px-3 py-1 rounded text-sm">💰 PayPal</span>
      <span className="bg-gray-700 px-3 py-1 rounded text-sm">🏦 تحويل بنكي</span>
    </div>
    <form className="space-y-3 mt-4 text-sm">
      <label className="block text-xs text-gray-300" htmlFor="fullname">الاسم الكامل</label>
      <input className="w-full px-3 py-1 rounded bg-gray-900 text-white" id="fullname" name="fullname" type="text" />
      <label className="block text-xs text-gray-300" htmlFor="email">البريد الإلكتروني</label>
      <input className="w-full px-3 py-1 rounded bg-gray-900 text-white" id="email" name="email" type="text" />
      <label className="block text-xs text-gray-300" htmlFor="phone">رقم الهاتف</label>
      <input className="w-full px-3 py-1 rounded bg-gray-900 text-white" id="phone" name="phone" type="text" />
      <button className="bg-green-600 text-white px-4 py-2 rounded w-full hover:bg-green-700 transition" type="submit">
        إرسال المعلومات
      </button>
    </form>
  </div>
</section>


      <section
        className="hidden mt-8 bg-gray-800 p-6 rounded shadow max-w-xl mx-auto text-sm"
        id="contact-form"
      >
        <h2 className="text-xl font-semibold text-center mb-4">Contact Us</h2>
        <form className="space-y-4 text-sm">
          <label className="block text-gray-300" for="fullname">
            Full Name
          </label>
          <input
            className="w-full px-3 py-1 rounded bg-gray-900 text-white text-sm"
            id="fullname"
            name="fullname"
            type="text"
          />
          <label className="block text-gray-300" for="email">
            Email
          </label>
          <input
            className="w-full px-3 py-1 rounded bg-gray-900 text-white text-sm"
            id="email"
            name="email"
            type="text"
          />
          <label className="block text-gray-300" for="subject">
            Subject
          </label>
          <input
            className="w-full px-3 py-1 rounded bg-gray-900 text-white text-sm"
            id="subject"
            name="subject"
            type="text"
          />
          <label className="block text-gray-300" for="message">
            Message
          </label>
          <textarea
            className="w-full px-3 py-1 rounded bg-gray-900 text-white text-sm"
            id="message"
            name="message"
          ></textarea>
          <button
            className="bg-blue-600 text-white px-4 py-2 rounded w-full mt-2 hover:bg-blue-700 transition"
            type="submit"
          >
            Send Message
          </button>
        </form>
      </section>
      <section
        className="hidden mt-10 bg-gray-800 p-6 rounded shadow max-w-xl mx-auto text-sm"
        id="faq-section"
      >
        <h2 className="text-xl font-semibold text-center mb-4">
          Frequently Asked Questions
        </h2>
        <div className="border-b border-gray-700 py-2">
          <p
            className="font-semibold cursor-pointer hover:text-blue-400"
            onClick={() => {
              document.getElementById("1").classList.toggle("hidden");
            }}
          >
            How long does it take to complete a website?
          </p>
          <p className="hidden text-gray-300 mt-1" id="1">
            Usually between 5 to 10 days depending on the project.
          </p>
        </div>
        <div className="border-b border-gray-700 py-2">
          <p
            className="font-semibold cursor-pointer hover:text-blue-400"
            onClick={() => {
              document.getElementById("2").classList.toggle("hidden");
            }}
          >
            Can I request changes after delivery?
          </p>
          <p className="hidden text-gray-300 mt-1" id="2">
            Yes, minor changes are included within 7 days after delivery.
          </p>
        </div>
        <div className="border-b border-gray-700 py-2">
          <p
            className="font-semibold cursor-pointer hover:text-blue-400"
            onClick={() => {
              document.getElementById("3").classList.toggle("hidden");
            }}
          >
            Do you offer hosting services?
          </p>
          <p className="hidden text-gray-300 mt-1" id="3">
            Yes, hosting and domain registration are part of our full package.
          </p>
        </div>
      </section>

      <button
        onClick={() => {
          window.scrollTo(0, 0);
        }}
        style={{
          position: "fixed",
          bottom: "20px",
          left: "20px",
          backgroundColor: "#333",
          color: " white",
          border: "none",
          borderRadius: "50%",
          padding: "12px 16px",
          fontSize: "20px",
          cursor: "pointer",
          zIndex: "1000",
        }}
        title="Scroll to top"
      >
        ⬆️
      </button>

      <div
        className="fixed bottom-6 right-6 bg-green-600 hover:bg-green-700 text-white rounded-full shadow-lg p-4 cursor-pointer z-50"
        id="chat-bubble"
        onClick={() => {
          alert("Chat coming soon!");
        }}
      >
        💬
 </div>

{/* ✅ Privacy Policy Section */}
{visibleSection === "privacy" && (
  <section
    id="privacy"
    className="py-12 px-4 bg-gray-900 text-white text-sm max-w-3xl mx-auto rounded shadow my-8"
  >
    <h2
      className="text-2xl font-bold mb-4 text-center"
      data-lang-ar="سياسة الخصوصية"
      data-lang-en="Privacy Policy"
    >
      Privacy Policy
    </h2>
    <div className="space-y-4 text-gray-300 leading-relaxed">
      <p
        data-lang-ar="نلتزم بحماية معلوماتك الشخصية وخصوصيتك. توضح هذه السياسة كيف نقوم بجمع واستخدام وحماية بياناتك عند استخدامك لموقعنا."
        data-lang-en="We are committed to protecting your personal information and your right to privacy. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our website."
      >
        We are committed to protecting your personal information and your right to privacy. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our website.
      </p>
      <p
        data-lang-ar="لا نقوم بمشاركة أو بيع أو تأجير معلوماتك مع أي جهة خارجية لأغراض ترويجية."
        data-lang-en="We do not share, sell, rent, or trade your information with third parties for their promotional purposes."
      >
        We do not share, sell, rent, or trade your information with third parties for their promotional purposes.
      </p>
      <p
        data-lang-ar="نجمع فقط البيانات التي تقدمها طوعاً مثل الاسم والبريد والهاتف عبر النماذج."
        data-lang-en="We may collect personal information such as your name, email, or phone number only when you voluntarily submit it through forms or interactions on the site."
      >
        We may collect personal information such as your name, email, or phone number only when you voluntarily submit it through forms or interactions on the site.
      </p>
      <p
        data-lang-ar="يتم تخزين بياناتك بأمان ولا يُسمح بالوصول إليها إلا للأشخاص المخولين."
        data-lang-en="All data collected is stored securely and is only accessible to authorized personnel."
      >
        All data collected is stored securely and is only accessible to authorized personnel.
      </p>
      <p
        data-lang-ar="باستخدامك للموقع، فإنك توافق على هذه السياسة. إذا لم توافق، يُرجى عدم استخدام الموقع."
        data-lang-en="By using this site, you consent to the terms of this Privacy Policy. If you do not agree, please refrain from using our website."
      >
        By using this site, you consent to the terms of this Privacy Policy. If you do not agree, please refrain from using our website.
      </p>
    </div>
  </section>
)}

{/* ✅ Terms & Conditions Section */}
{visibleSection === "terms" && (
  <section
    id="terms"
    className="py-12 px-4 bg-gray-900 text-white text-sm max-w-3xl mx-auto rounded shadow my-8"
  >
    <h2
      className="text-2xl font-bold mb-4 text-center"
      data-lang-ar="الشروط والأحكام"
      data-lang-en="Terms & Conditions"
    >
      Terms & Conditions
    </h2>
    <div className="space-y-4 text-gray-300 leading-relaxed">
      <p
        data-lang-ar="باستخدامك لهذا الموقع، فإنك توافق على الالتزام بهذه الشروط. إذا لم توافق على أي جزء منها، يُرجى التوقف عن استخدام الموقع."
        data-lang-en="By accessing or using this website, you agree to be bound by these terms and conditions. If you do not agree with any part of the terms, you must discontinue use."
      >
        By accessing or using this website, you agree to be bound by these terms and conditions. If you do not agree with any part of the terms, you must discontinue use.
      </p>
      <p
        data-lang-ar="قد نقوم بتغيير أو إزالة أي محتوى في الموقع في أي وقت دون إشعار مسبق."
        data-lang-en="We reserve the right to change or remove any content without notice."
      >
        We reserve the right to change or remove any content without notice.
      </p>
      <p
        data-lang-ar="يجب عليك التأكد من أن استخدامك للموقع يتوافق مع القوانين المحلية والدولية."
        data-lang-en="You are responsible for ensuring that your use of this website complies with all applicable laws and regulations."
      >
        You are responsible for ensuring that your use of this website complies with all applicable laws and regulations.
      </p>
      <p
        data-lang-ar="جميع الشعارات والمحتوى مملوكة لأصحابها، ويُحظر استخدامها بدون إذن."
        data-lang-en="All trademarks, logos, and content on this site are the property of their respective owners. Unauthorized use is prohibited."
      >
        All trademarks, logos, and content on this site are the property of their respective owners. Unauthorized use is prohibited.
      </p>
      <p
        data-lang-ar="نحن لا نضمن دقة المعلومات على الموقع ونخلي مسؤوليتنا عن أي ضرر قد ينشأ."
        data-lang-en="We make no warranties regarding the accuracy or reliability of any information provided and disclaim liability for any damages arising from use."
      >
        We make no warranties regarding the accuracy or reliability of any information provided and disclaim liability for any damages arising from use.
      </p>
      <p
        data-lang-ar="تخضع هذه الشروط للقوانين المعمول بها، ويتم حل النزاعات أمام الجهات المختصة."
        data-lang-en="These terms are governed by the laws of the applicable jurisdiction, and disputes will be resolved in the appropriate courts."
      >
        These terms are governed by the laws of the applicable jurisdiction, and disputes will be resolved in the appropriate courts.
      </p>
    </div>
  </section>
)}



<footer className="text-center py-6 text-gray-400 border-t border-gray-700 text-[16px] font-thin leading-tight tracking-wide">
  <p>© 2025 Jalal Ali. All rights reserved.</p>

  <div className="mt-3 space-y-0.5">
    <p>📍 252 شارع الذهبيه، أمام باب العاملين بفندق ذهبيه</p>

    <p>
      📞 موبايل / واتساب:
      <a
        href="https://wa.me/201031471772"
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-400 hover:underline ml-1"
      >
        01031471772
      </a>
    </p>

    <p>
      ✉️ البريد الإلكتروني:
      <a
        href="mailto:info@codectafted.net"
        className="text-blue-400 hover:underline ml-1"
      >
        info@codectafted.net
      </a>
    </p>
  </div>

  <div className="mt-4">
    <button
      onClick={() => toggleSection("privacy")}
      className="hover:underline text-blue-400"
    >
      Privacy Policy
    </button>
    |
    <button
      onClick={() => toggleSection("terms")}
      className="hover:underline text-blue-400"
    >
      Terms & Conditions
    </button>
  </div>
</footer>
</>
);
};






export default App;
